import React from "react";
import "./Subtotal.css";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../StateProvider";
import { getCartTotal } from "../../reducer";

function Subtotal() {
  const navigate = useNavigate();
  const [{ cart, user }] = useStateValue();

  const totalItems = cart.reduce((t, i) => t + i.quantity, 0);
  const subtotal = getCartTotal(cart);

  const fmt = (n) =>
    new Intl.NumberFormat("en-NG", {
      style: "currency", currency: "NGN", minimumFractionDigits: 2,
    }).format(n);

  const handleCheckout = () => {
    if (user) {
      if (user.emailVerification) {
        navigate("/checkout");
      } else {
        navigate("/account/email-verification");
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="subtotal">
      <h3 className="subtotal__title">Order Summary</h3>
      <div className="subtotal__row">
        <span>Subtotal ({totalItems} {totalItems === 1 ? "item" : "items"})</span>
        <span>{fmt(subtotal)}</span>
      </div>
      <div className="subtotal__row">
        <span>Shipping</span>
        <span className="subtotal__muted">Awaiting Rider</span>
      </div>
      <div className="subtotal__row">
        <span>Tax</span>
        <span className="subtotal__muted">At Checkout</span>
      </div>
      <div className="subtotal__total">
        <span>Estimated Total</span>
        <strong>{fmt(subtotal)}</strong>
      </div>
      <button className="subtotal__btn" onClick={handleCheckout}>
        Proceed to Checkout
      </button>
    </div>
  );
}

export default Subtotal;
